import { useOrderSettings } from './use-order-settings'

export function useMaxDeliveryDays() {
  const orderSettings = useOrderSettings()
  return orderSettings?.maximumFutureDeliveryDays ?? 28
}
